import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from 'react';
import AdminLayout from 'Components/Admin/AdminLayout';
import { Container, Spinner } from 'reactstrap';
export default function Main() {
  const {
    t
  } = useTranslation();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchStats = async () => {
      try {
        const API_BASE = process.env.REACT_APP_API_URL || 'https://api.heresmyinfo.com/api';
        const token = localStorage.getItem('HMI_AUTH_TOKEN');
        const headers = {
          'Content-Type': 'application/json'
        };

        if (token) {
          headers['Authorization'] = `Bearer ${token}`;
        }

        const response = await fetch(`${API_BASE}/admin/overview-stats`, {
          headers: headers
        });
        const data = await response.json();

        if (data.success && data.data) {
          setStats(data.data);
        } else {
          // eslint-disable-next-line no-mixed-operators
          setError(data.error && data.error.message || 'Failed to fetch stats');
        }
      } catch (err) {
        setError(err.message || 'Network error');
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);
  return <AdminLayout>
      <Container>
        <h4 className="mb-4" style={{
        fontSize: '1.5rem',
        textTransform: 'none',
        letterSpacing: 'normal',
        fontWeight: 600,
        color: 'white'
      }}>{t("HMI Administration Overview")}</h4>
        <hr style={{
        borderColor: 'rgba(255, 255, 255, 0.1)'
      }} />
        
        {loading ? <Spinner color="light" /> : error ? <p className="text-danger">{t("Error:")}{error}</p> : <div className="mt-3">
            <h5 className="mb-3" style={{
          fontSize: '1.1rem',
          fontWeight: 500,
          color: 'white'
        }}>{t("Total # users in system:")}{stats ? stats.totalUsers || 0 : 0}</h5>
            <h5 className="mb-3" style={{
          fontSize: '1.1rem',
          fontWeight: 500,
          color: 'white'
        }}>{t("Total # Businesses:")}{stats ? stats.totalBusinesses || 0 : 0}</h5>
            <h5 className="mb-3" style={{
          fontSize: '1.1rem',
          fontWeight: 500,
          color: 'white'
        }}>{t("New users today:")}{stats ? stats.newUsersToday || 0 : 0}</h5>
            <h5 className="mb-3" style={{
          fontSize: '1.1rem',
          fontWeight: 500,
          color: 'white'
        }}>{t("Average daily signups:")}{stats ? stats.averageDailySignups || 0 : 0}</h5>
          </div>}
      </Container>
    </AdminLayout>;
}